import { OperatorFunction } from 'rxjs';
import { filter } from 'rxjs/operators';

export function filterEmpty<T>(): OperatorFunction<T | null | undefined, T> {
  return filter<T | null | undefined, T>((value): value is T => value !== undefined && value !== null);
}
